import { INIT_PAGE_STATE } from "../../constant/constant";
import {
  ENTRA_LOG_GET_LIST,
  ENTRA_LOG_GET_LIST_SUCCESS,
  ENTRA_LOG_GET_LIST_ERROR
} from "./actions";

const INIT_STATE = {
  list: {
    data: null,
    loading: false,
    error: false,
    filter: null,
    deleteFlag: null,
    orderBy: "id",
    sortedBy: "asc",
    message: null,
    page: INIT_PAGE_STATE,
  },
};

const entraLogReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ENTRA_LOG_GET_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          filter: action.payload.filter,
          deleteFlag: action.payload.deleteFlag,
          orderBy: action.payload.orderBy,
          sortedBy: action.payload.sortedBy,
        },
      };

    case ENTRA_LOG_GET_LIST_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          data: action.payload.data.map((t) => {
            return {
              ...t,
              id: Number(t.id),
              ...t.attributes,
            };
          }),
          page: {
            ...state.list.page,
            currentPage: action.payload.meta.pagination.current_page,
            selectedPageSize: action.payload.meta.pagination.per_page,
            totalItem: action.payload.meta.pagination.total_item,
            totalPage: action.payload.meta.pagination.total_page,
            itemCount: action.payload.meta.pagination.item_count,
          },
          loading: false,
          error: false,
          message: null,
        },
      };
    }

    case ENTRA_LOG_GET_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          data: null,
          loading: false,
          error: true,
          page: INIT_PAGE_STATE,
          message: action.payload,
        },
      };

    default:
      return state;
  }
};

export default entraLogReducer;
